// extracted by mini-css-extract-plugin
module.exports = {"benefits":"styles_benefits__12p2_","column":"styles_column__2mDI8","defs":"styles_defs__1LYCI"};